export default `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
    <path d="M15.26,4.74h3.68V0H15.26C12.11,0,9.61,2.76,9.61,6.32V8.68H5.92v4.74H9.61V25h4.74V13.42h4.74V8.68H14.34V6.18C14.34,5.39,14.87,4.74,15.26,4.74Z"/>
</svg>`;
